<template>
  <div
    @click="toggle()"
    :style="{ width: widthPx, height: heightPx, position: 'relative' }"
    class="text-center hyp-selector-container"
    :class="{
      'hyp-selector-container-active': isSelected,
      'hyp-selector-container-border': !onlyShowBorderOnSelected,
    }"
  >
    <v-avatar class="mb-1 hyp-selector-btn" :size="circleSize">
      <v-icon v-if="icon" class="hyp-selector-icon">{{ icon }}</v-icon>
      <img v-if="imgSrc" :src="imgSrc" :alt="title" />
    </v-avatar>
    <div
      v-if="title"
      :style="{ 'font-size': fontSize }"
      class="hyp-selector-text"
      :class="{ 'hyp-selector-text-active': isSelected }"
    >
      {{ title }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { GET_SELECTOR_PANEL } from "@/store/actions.type";
import { MODULE_PREFIX_HOME } from "@/store";
import { ICONS } from "@/common/constants/icons";

const EMITTED_ACTIONS = {
  CLICK: "click",
};

export default {
  name: "SelectorButton",
  props: {
    title: {
      type: String,
    },
    width: {
      type: Number,
      default: 87,
    },
    height: {
      type: Number,
      default: 79,
    },
    circleSize: {
      type: Number,
      default: 30,
    },
    icon: {
      type: String,
    },
    type: {
      type: String,
      validator: function (value) {
        let types = [
          "hotspots",
          "hotspotsCovid",
          "travelTracker",
          "powerOutage",
        ];
        return types.indexOf(value) !== -1;
      },
    },
    fontSize: {
      type: String,
      default: "14px",
    },
    onlyShowBorderOnSelected: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selected: false,
  }),
  computed: {
    ...mapGetters({
      selectorPanel: MODULE_PREFIX_HOME + "selectorPanel",
    }),
    isSelected: {
      get() {
        return this.selected;
      },
      set(value) {
        this.selected = value;
      },
    },
    widthPx() {
      return `${this.width}px`;
    },
    heightPx() {
      return `${this.height}px`;
    },
    imgSrc() {
      if (this.type && ICONS.types[this.type]) {
        let src = ICONS.types[this.type].inactive;
        if (this.isSelected) {
          src = ICONS.types[this.type].active;
        }
        return require(`@/assets/images${src}`);
      }
      return null;
    },
  },
  methods: {
    toggle() {
      this.isSelected = !this.isSelected;
      this.selectorPanel[this.type] = this.isSelected;
      this.$store.dispatch(
        MODULE_PREFIX_HOME + GET_SELECTOR_PANEL,
        this.selectorPanel
      );
      this.$emit(EMITTED_ACTIONS.CLICK, {
        type: this.type,
        selected: this.isSelected,
      });
    },
  },
  watch: {
    selectorPanel: {
      handler() {
        if (this.selectorPanel) {
          this.isSelected = false;
          if (this.selectorPanel[this.type]) {
            this.isSelected = true;
          }
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.hyp-selector-container {
  width: 87px;
  height: 79px;
  cursor: pointer;
}
.hyp-selector-container-border {
  background-color: white;
  border: 1px solid rgba(175, 175, 185, 0.41);
  border-radius: 9px;
}
.hyp-selector-container-active {
  border: 1px solid rgba(75, 73, 255, 0.41);
  box-shadow: 0 2px 11px 0 rgba(75, 73, 255, 0.23);
  -webkit-box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.14) !important;
  border-radius: 9px;
}
.hyp-selector-btn {
  margin-top: 15px;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.14) !important;
  -webkit-box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.14) !important;
}
.hyp-selector-btn-active {
  background-color: #1e1e1e !important;
  color: white !important;
}
.hyp-selector-icon {
  font-size: 11pt;
  color: white;
}
.hyp-selector-text {
  color: #1e1e1e;
  opacity: 0.48;
}
.hyp-selector-text-active {
  color: #1e1e1e !important;
  opacity: 1 !important;
  font-weight: 700 !important;
}
</style>
<style>
.v-dialog__content .hyp-selector-container {
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.14) !important;
  -webkit-box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.14) !important;
}
</style>
